import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import { _ as _objectSpread2 } from '../_rollupPluginBabelHelpers-05128ded.js';
import React__default, { useCallback, useRef, useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { N as NodeTypes, M as MessageInputKeys, a as NodeNames } from '../const-3a34a127.js';
import { U as USER_MENTION_TEMP_CHAR } from '../const-72f012b6.js';
import IconButton from './IconButton.js';
import Button, { ButtonTypes, ButtonSizes } from './Button.js';
import DOMPurify from 'dompurify';
import { M as MENTION_USER_LABEL_CLASSNAME } from '../consts-b4cb83cf.js';
import Icon, { IconTypes, IconColors } from './Icon.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import { u as useLocalization } from '../LocalizationContext-a82461b5.js';
import useSendbirdStateContext from '../useSendbirdStateContext.js';
import { j as arrayEqual, h as getClassName } from '../index-579ca9d7.js';
import { T as TEXT_MESSAGE_BODY_CLASSNAME } from '../consts-7693b8d3.js';
import { O as OG_MESSAGE_BODY_CLASSNAME } from '../consts-9469111b.js';
import { t as tokenizeMessage, T as TOKEN_TYPES, U as USER_MENTION_PREFIX } from '../tokenize-c718324d.js';
import { K } from '../index.module-4f1cd64e.js';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import '../withSendbird.js';
import '../utils/message/getOutgoingMessageState.js';

// cretes a sanitized string from a mention user label
function renderToString(_ref) {
  var userId = _ref.userId,
    nickname = _ref.nickname; // donot change this template, it wont work
  var el = "<span data-userid=\"".concat(userId, "\" data-sb-mention=\"true\" class=\"").concat(MENTION_USER_LABEL_CLASSNAME, "\">").concat(nickname, "</span>");
  var purifier = DOMPurify(window);
  var sanitized_ = purifier.sanitize(el);
  var token = sanitized_.split(' ');
  var _token = _toArray(token),
    spanTag = _token[0],
    rest = _token.slice(1); // we do this because DOMPurify removes the contenteditable attribute
  var sanitized = [spanTag, 'contenteditable="false"'].concat(_toConsumableArray(rest)).join(' ');
  return sanitized;
}

// https://davidwalsh.name/javascript-debounce-function

// Sanitize that special characters of HTML tags cause XSS issue
var sanitizeString = function sanitizeString(str) {
  return str === null || str === void 0 ? void 0 : str.replace(/[\u00A0-\u9999<>]/gim, function (i) {
    return ''.concat('&#', i.charCodeAt(0), ';');
  });
};

/**
 * NodeList cannot be used with Array methods
 * @param {childNodes} NodeList
 * @returns Array of child nodes
 */
var nodeListToArray = function nodeListToArray(childNodes) {
  try {
    return Array.from(childNodes);
  } catch (error) {
    return [];
  }
};
function inserTemplateToDOM(templateList) {
  var nodes = templateList.map(function (template) {
    var text = template.text,
      userId = template.userId;
    if (userId) {
      return renderToString({
        userId: userId,
        nickname: text
      });
    }
    return sanitizeString(text);
  }).join(' ')
  // add a space at the end of the mention, else cursor/caret wont work
  .concat(' ');
  document.execCommand('insertHTML', false, nodes);
}
var PASTE_NODE = 'sendbird-uikit__paste-node';
var TEXT_MESSAGE_CLASS = 'sendbird-word';
var MENTION_CLASS = 'sendbird-word__mention';
var MENTION_CLASS_IN_INPUT = 'sendbird-mention-user-label';
var MENTION_CLASS_COMBINED_QUERY = ".".concat(MENTION_CLASS, ", .").concat(MENTION_CLASS_IN_INPUT);
function querySelectorIncludingSelf(master, selector) {
  var result = [master].concat(_toConsumableArray(Array.from(master.querySelectorAll(selector)))).find(function (el) {
    return el.matches(selector);
  });
  return result;
}

// Pasted dom node can be OG_MESSAGE or partial message or full message
// full messsage would have TEXT_MESSAGE_BODY_CLASSNAME and have childNodes
// partial message would not have TEXT_MESSAGE_BODY_CLASSNAME
function getLeafNodes(master) {
  // og message
  var ogMessage = querySelectorIncludingSelf(master, ".".concat(OG_MESSAGE_BODY_CLASSNAME));
  if (ogMessage) {
    return nodeListToArray(ogMessage.childNodes);
  }
  var textMessageBody = querySelectorIncludingSelf(master, ".".concat(TEXT_MESSAGE_BODY_CLASSNAME));
  if (textMessageBody) {
    return nodeListToArray(textMessageBody.childNodes);
  }
  return nodeListToArray(master.childNodes);
}
function createPasteNode() {
  var pasteNode = document.body.querySelector("#".concat(PASTE_NODE));
  // remove existing paste node
  if (pasteNode) {
    pasteNode === null || pasteNode === void 0 ? void 0 : pasteNode.remove();
  }

  // create new paste node and return
  var node = document.createElement('div');
  node.id = PASTE_NODE;
  node.style.display = 'none';
  return node;
}
function hasMention(parent) {
  return parent !== null && parent !== void 0 && parent.querySelector(MENTION_CLASS_COMBINED_QUERY) ? true : false;
}
var extractTextFromNodes = function extractTextFromNodes(nodes) {
  var text = '';
  nodes.forEach(function (node) {
    // to preserve space between words
    var textNodes = node.querySelectorAll(".".concat(TEXT_MESSAGE_CLASS));
    if (textNodes.length > 0) {
      text += extractTextFromNodes(Array.from(textNodes)) + ' ';
    }
    text += node.innerText + ' ';
  });
  return text;
};
function domToMessageTemplate(nodeArray) {
  var templates = nodeArray === null || nodeArray === void 0 ? void 0 : nodeArray.reduce(function (accumulator, currentValue) {
    // currentValue can be node(from messageBody or messageInput) or text
    var mentionNode;
    // this looks awkward, but it is a fallback to set default text
    var text = currentValue === null || currentValue === void 0 ? void 0 : currentValue.innerText;

    // if text node, set text
    if (currentValue instanceof Text) {
      mentionNode = false;
      text = currentValue.textContent;
    }
    if (currentValue instanceof HTMLElement) {
      mentionNode = currentValue.classList.contains(MENTION_CLASS) || currentValue.classList.contains(MENTION_CLASS_IN_INPUT) ? currentValue : currentValue.querySelector(MENTION_CLASS_COMBINED_QUERY);
    }

    // if mentionNode is not null, it is a mention
    if (mentionNode) {
      var _mentionNode$dataset;
      var _text = currentValue === null || currentValue === void 0 ? void 0 : currentValue.innerText;
      var userId = (_mentionNode$dataset = mentionNode.dataset) === null || _mentionNode$dataset === void 0 ? void 0 : _mentionNode$dataset.userid;
      return [].concat(_toConsumableArray(accumulator), [{
        text: _text,
        userId: userId
      }]);
    }
    return [].concat(_toConsumableArray(accumulator), [{
      text: text
    }]);
  }, []);
  return templates;
}
function getUsersFromWords(templates, channel) {
  var userMap = {};
  var users = channel.members;
  templates.forEach(function (template) {
    if (template.userId) {
      var mentionedMember = users.find(function (user) {
        return user.userId === template.userId;
      });
      // Object.values would return array-> [undefined] if the user is not in the channel
      if (mentionedMember) {
        userMap[template.userId] = mentionedMember;
      }
    }
  });
  return Object.values(userMap);
}

// conditions to test:
// 1. paste simple text
// 2. paste text with mention
// 3. paste text with mention and text
// 4. paste text with mention and text and paste again before and after
// 5. copy message with mention(only one mention, no other text) and paste
// 6. copy message with mention from input and paste(before and after)
function usePaste(_ref) {
  var ref = _ref.ref,
    setIsInput = _ref.setIsInput,
    setHeight = _ref.setHeight,
    channel = _ref.channel,
    setMentionedUsers = _ref.setMentionedUsers;
  return useCallback(function (e) {
    e.preventDefault();
    var html = e === null || e === void 0 ? void 0 : e.clipboardData.getData('text/html');
    // simple text, continue as normal
    if (!html) {
      var text = e === null || e === void 0 ? void 0 : e.clipboardData.getData('text');
      document.execCommand('insertHTML', false, sanitizeString(text));
      setIsInput(true);
      setHeight();
      return;
    }

    // has html, check if there are mentions, sanitize and insert
    var purifier = DOMPurify(window);
    var clean = purifier.sanitize(html);
    var pasteNode = createPasteNode();
    pasteNode.innerHTML = clean;
    // does not have mention, continue as normal
    if (!hasMention(pasteNode)) {
      // to preserve space between words
      var _text2 = extractTextFromNodes(Array.from(pasteNode.children));
      document.execCommand('insertHTML', false, sanitizeString(_text2));
      pasteNode.remove();
      setIsInput(true);
      setHeight();
      return;
    }

    // has mention, collect leaf nodes and parse words
    var leafNodes = getLeafNodes(pasteNode);
    var words = domToMessageTemplate(leafNodes);
    var mentionedUsers = getUsersFromWords(words, channel);

    // side effects
    setMentionedUsers(mentionedUsers);
    inserTemplateToDOM(words);
    pasteNode.remove();
    setIsInput(true);
    setHeight();
  }, [ref, setIsInput, setHeight, channel, setMentionedUsers]);
}

/**
 * Write new utils here
 * Migrate old utils as needed, and delete utils.js
 */
/**
 * FIXME:
 * Import this ChannelType enum from @sendbird/chat
 * once MessageInput.spec unit tests can be run \wo jest <-> ESM issue
 */
var ChannelType = /*#__PURE__*/function (ChannelType) {
  ChannelType["BASE"] = "base";
  ChannelType["GROUP"] = "group";
  ChannelType["OPEN"] = "open";
  return ChannelType;
}(ChannelType || {});
/**
 * FIXME: Simplify this in UIKit@v4
 * If customer is using MessageInput inside our modules(ie: Channel, Thread, etc),
 * we should use the config from the module.
 * If customer is using MessageInput outside our modules(ie: custom UI),
 * we expect Channel to be undefined and customer gets control to show/hide file-upload.
 * @param {*} channel GroupChannel | OpenChannel
 * @param {*} config SendBirdStateConfig
 * @returns boolean
 */
var checkIfFileUploadEnabled = function checkIfFileUploadEnabled(_ref) {
  var channel = _ref.channel,
    config = _ref.config;
  var isEnabled = K(channel === null || channel === void 0 ? void 0 : channel.channelType).with(ChannelType.GROUP, function () {
    var _config$groupChannel;
    return config === null || config === void 0 ? void 0 : (_config$groupChannel = config.groupChannel) === null || _config$groupChannel === void 0 ? void 0 : _config$groupChannel.enableDocument;
  }).with(ChannelType.OPEN, function () {
    var _config$openChannel;
    return config === null || config === void 0 ? void 0 : (_config$openChannel = config.openChannel) === null || _config$openChannel === void 0 ? void 0 : _config$openChannel.enableDocument;
  }).otherwise(function () {
    return true;
  });
  return isEnabled;
};
var TEXT_FIELD_ID = 'sendbird-message-input-text-field';
var LINE_HEIGHT = 76;
var noop = function noop() {};
var handleUploadFile = function handleUploadFile(callback) {
  return function (event) {
    if (event.target.files && event.target.files[0]) {
      callback(event.target.files[0]);
    }
    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
  };
};
var displayCaret = function displayCaret(element, position) {
  var range = document.createRange();
  var sel = window.getSelection();
  range.setStart(element.childNodes[0], position);
  range.collapse(true);
  sel.removeAllRanges();
  sel.addRange(range);
  element.focus();
};
var resetInput = function resetInput(ref) {
  try {
    /* eslint-disable no-param-reassign */
    ref.current.innerHTML = '';
  } catch (_unused) {
    //
  }
};
var initialTargetStringInfo = {
  targetString: '',
  startNodeIndex: null,
  startOffsetIndex: null,
  endNodeIndex: null,
  endOffsetIndex: null
};
var MessageInput = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _ref$current, _ref$current$textCont, _textField$innerText;
  var className = props.className,
    messageFieldId = props.messageFieldId,
    isEdit = props.isEdit,
    isMentionEnabled = props.isMentionEnabled,
    isVoiceMessageEnabled = props.isVoiceMessageEnabled,
    disabled = props.disabled,
    message = props.message,
    placeholder = props.placeholder,
    maxLength = props.maxLength,
    onFileUpload = props.onFileUpload,
    onSendMessage = props.onSendMessage,
    onUpdateMessage = props.onUpdateMessage,
    onCancelEdit = props.onCancelEdit,
    onStartTyping = props.onStartTyping,
    channelUrl = props.channelUrl,
    channel = props.channel,
    mentionSelectedUser = props.mentionSelectedUser,
    onUserMentioned = props.onUserMentioned,
    onMentionStringChange = props.onMentionStringChange,
    onMentionedUserIdsUpdated = props.onMentionedUserIdsUpdated,
    onVoiceMessageIconClick = props.onVoiceMessageIconClick,
    _onKeyUp = props.onKeyUp,
    _onKeyDown = props.onKeyDown,
    renderFileUploadIcon = props.renderFileUploadIcon,
    renderVoiceMessageIcon = props.renderVoiceMessageIcon,
    renderSendMessageIcon = props.renderSendMessageIcon,
    setMentionedUsers = props.setMentionedUsers;
  var textFieldId = messageFieldId || TEXT_FIELD_ID;
  var _useLocalization = useLocalization(),
    stringSet = _useLocalization.stringSet;
  var _useSendbirdStateCont = useSendbirdStateContext(),
    config = _useSendbirdStateCont.config;
  var isFileUploadEnabled = checkIfFileUploadEnabled({
    channel: channel,
    config: config
  });
  var fileInputRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInput = _useState2[0],
    setIsInput = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    mentionedUserIds = _useState4[0],
    setMentionedUserIds = _useState4[1];
  var _useState5 = useState(_objectSpread2({}, initialTargetStringInfo)),
    _useState6 = _slicedToArray(_useState5, 2),
    targetStringInfo = _useState6[0],
    setTargetStringInfo = _useState6[1];
  var setHeight = useMemo(function () {
    return function () {
      try {
        var elem = ref === null || ref === void 0 ? void 0 : ref.current;
        var MAX_HEIGHT = window.document.body.offsetHeight * 0.6;
        if (elem && elem.scrollHeight >= LINE_HEIGHT) {
          if (MAX_HEIGHT < elem.scrollHeight) {
            elem.style.height = 'auto';
            elem.style.height = "".concat(MAX_HEIGHT, "px");
          } else {
            elem.style.height = 'auto';
            elem.style.height = "".concat(elem.scrollHeight, "px");
          }
        } else {
          elem.style.height = '';
        }
      } catch (error) {
        // error
      }
    };
  }, []);

  // #Edit mode
  // for easilly initialize input value from outside, but
  // useEffect(_, [channelUrl]) erase it
  var initialValue = props === null || props === void 0 ? void 0 : props.value;
  useEffect(function () {
    var _textField$textConten;
    var textField = ref === null || ref === void 0 ? void 0 : ref.current;
    try {
      textField.innerHTML = initialValue;
      displayCaret(textField, initialValue === null || initialValue === void 0 ? void 0 : initialValue.length);
    } catch (_unused2) {
      //
    }
    setMentionedUserIds([]);
    setIsInput((textField === null || textField === void 0 ? void 0 : (_textField$textConten = textField.textContent) === null || _textField$textConten === void 0 ? void 0 : _textField$textConten.trim().length) > 0);
    setHeight();
  }, [initialValue]);

  // #Mention | Clear input value when channel changes
  useEffect(function () {
    if (!isEdit) {
      setIsInput(false);
      resetInput(ref);
    }
  }, [channelUrl]);

  // #Mention & #Edit | Fill message input values
  useEffect(function () {
    if (isEdit && message !== null && message !== void 0 && message.messageId) {
      var _message$mentionedUse, _message$mentionedMes, _textField$textConten2;
      // const textField = document.getElementById(textFieldId);
      var _textField = ref === null || ref === void 0 ? void 0 : ref.current;
      if (isMentionEnabled && (message === null || message === void 0 ? void 0 : (_message$mentionedUse = message.mentionedUsers) === null || _message$mentionedUse === void 0 ? void 0 : _message$mentionedUse.length) > 0 && (message === null || message === void 0 ? void 0 : (_message$mentionedMes = message.mentionedMessageTemplate) === null || _message$mentionedMes === void 0 ? void 0 : _message$mentionedMes.length) > 0) {
        /* mention enabled */
        var _message$mentionedUse2 = message.mentionedUsers,
          mentionedUsers = _message$mentionedUse2 === void 0 ? [] : _message$mentionedUse2;
        var tokens = tokenizeMessage({
          messageText: message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate,
          mentionedUsers: mentionedUsers
        });
        _textField.innerHTML = tokens.map(function (token) {
          if (token.type === TOKEN_TYPES.mention) {
            var mentionedUser = mentionedUsers.find(function (user) {
              return user.userId === token.userId;
            });
            var nickname = "".concat(USER_MENTION_PREFIX).concat((mentionedUser === null || mentionedUser === void 0 ? void 0 : mentionedUser.nickname) || token.value || stringSet.MENTION_NAME__NO_NAME);
            return renderToString({
              userId: token.userId,
              nickname: nickname
            });
          }
          return sanitizeString(token.value);
        }).join(' ');
      } else {
        /* mention disabled */
        try {
          _textField.innerHTML = sanitizeString(message === null || message === void 0 ? void 0 : message.message);
        } catch (_unused3) {
          //
        }
        setMentionedUserIds([]);
      }
      setIsInput((_textField === null || _textField === void 0 ? void 0 : (_textField$textConten2 = _textField.textContent) === null || _textField$textConten2 === void 0 ? void 0 : _textField$textConten2.trim().length) > 0);
      setHeight();
    }
  }, [isEdit, message]);

  // #Mention | Detect MentionedLabel modified
  var useMentionedLabelDetection = useCallback(function () {
    var _textField$textConten3;
    var textField = ref === null || ref === void 0 ? void 0 : ref.current;
    if (isMentionEnabled) {
      var newMentionedUserIds = _toConsumableArray(textField.getElementsByClassName('sendbird-mention-user-label')).map(function (node) {
        var _node$dataset;
        return node === null || node === void 0 ? void 0 : (_node$dataset = node.dataset) === null || _node$dataset === void 0 ? void 0 : _node$dataset.userid;
      });
      if (!arrayEqual(mentionedUserIds, newMentionedUserIds) || newMentionedUserIds.length === 0) {
        onMentionedUserIdsUpdated(newMentionedUserIds);
        setMentionedUserIds(newMentionedUserIds);
      }
    }
    setIsInput(((_textField$textConten3 = textField.textContent) === null || _textField$textConten3 === void 0 ? void 0 : _textField$textConten3.trim().length) > 0);
  }, [targetStringInfo, isMentionEnabled]);

  // #Mention | Replace selected user nickname to the MentionedUserLabel
  useEffect(function () {
    if (isMentionEnabled && mentionSelectedUser) {
      var targetString = targetStringInfo.targetString,
        startNodeIndex = targetStringInfo.startNodeIndex,
        startOffsetIndex = targetStringInfo.startOffsetIndex,
        endNodeIndex = targetStringInfo.endNodeIndex,
        endOffsetIndex = targetStringInfo.endOffsetIndex;
      if (targetString && startNodeIndex !== null && startOffsetIndex !== null) {
        var _document, _childNodes$startNode, _document2, _childNodes$endNodeIn;
        // const textField = document.getElementById(textFieldId);
        var _textField2 = ref === null || ref === void 0 ? void 0 : ref.current;
        var childNodes = nodeListToArray(_textField2 === null || _textField2 === void 0 ? void 0 : _textField2.childNodes);
        var frontTextNode = (_document = document) === null || _document === void 0 ? void 0 : _document.createTextNode((_childNodes$startNode = childNodes[startNodeIndex]) === null || _childNodes$startNode === void 0 ? void 0 : _childNodes$startNode.textContent.slice(0, startOffsetIndex));
        var backTextNode = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.createTextNode("\xA0".concat((_childNodes$endNodeIn = childNodes[endNodeIndex]) === null || _childNodes$endNodeIn === void 0 ? void 0 : _childNodes$endNodeIn.textContent.slice(endOffsetIndex)));
        var mentionLabel = renderToString({
          userId: mentionSelectedUser === null || mentionSelectedUser === void 0 ? void 0 : mentionSelectedUser.userId,
          nickname: "".concat(USER_MENTION_TEMP_CHAR).concat((mentionSelectedUser === null || mentionSelectedUser === void 0 ? void 0 : mentionSelectedUser.nickname) || stringSet.MENTION_NAME__NO_NAME)
        });
        var div = document.createElement('div');
        div.innerHTML = mentionLabel;
        var newNodes = [].concat(_toConsumableArray(childNodes.slice(0, startNodeIndex)), [frontTextNode, div.childNodes[0], backTextNode], _toConsumableArray(childNodes.slice(endNodeIndex + 1)));
        _textField2.innerHTML = '';
        newNodes.forEach(function (newNode) {
          _textField2.appendChild(newNode);
        });
        onUserMentioned(mentionSelectedUser);
        if (window.getSelection || document.getSelection) {
          // set caret postion
          var selection = window.getSelection() || document.getSelection();
          selection.removeAllRanges();
          var range = new Range();
          range.selectNodeContents(_textField2);
          range.setStart(_textField2.childNodes[startNodeIndex + 2], 1);
          range.setEnd(_textField2.childNodes[startNodeIndex + 2], 1);
          range.collapse(false);
          selection.addRange(range);
          _textField2.focus();
        }
        setTargetStringInfo(_objectSpread2({}, initialTargetStringInfo));
        setHeight();
        useMentionedLabelDetection();
      }
    }
  }, [mentionSelectedUser, isMentionEnabled]);

  // #Mention | Detect mentioning user nickname
  var useMentionInputDetection = useCallback(function () {
    var _window, _window$getSelection, _document3, _document3$getSelecti;
    var selection = ((_window = window) === null || _window === void 0 ? void 0 : (_window$getSelection = _window.getSelection) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.call(_window)) || ((_document3 = document) === null || _document3 === void 0 ? void 0 : (_document3$getSelecti = _document3.getSelection) === null || _document3$getSelecti === void 0 ? void 0 : _document3$getSelecti.call(_document3));
    var textField = ref === null || ref === void 0 ? void 0 : ref.current;
    if (selection.anchorNode === textField) {
      onMentionStringChange('');
    }
    if (isMentionEnabled && selection && selection.anchorNode === selection.focusNode && selection.anchorOffset === selection.focusOffset) {
      var textStack = '';
      var startNodeIndex = null;
      var startOffsetIndex = null;
      for (var index = 0; index < textField.childNodes.length; index += 1) {
        var currentNode = textField.childNodes[index];
        if (currentNode.nodeType === NodeTypes.TextNode) {
          /* text node */
          var textContent = currentNode === selection.anchorNode ? (currentNode === null || currentNode === void 0 ? void 0 : currentNode.textContent.slice(0, selection.anchorOffset)) || '' : (currentNode === null || currentNode === void 0 ? void 0 : currentNode.textContent) || '';
          if (textStack.length > 0) {
            textStack += textContent;
          } else {
            var charLastIndex = textContent.lastIndexOf(USER_MENTION_TEMP_CHAR);
            for (var i = charLastIndex - 1; i > -1; i -= 1) {
              if (textContent[i] === USER_MENTION_TEMP_CHAR) {
                charLastIndex = i;
              } else {
                break;
              }
            }
            if (charLastIndex > -1) {
              textStack = textContent;
              startNodeIndex = index;
              startOffsetIndex = charLastIndex;
            }
          }
        } else {
          /* other nodes */
          textStack = '';
          startNodeIndex = null;
          startOffsetIndex = null;
        }
        if (currentNode === selection.anchorNode) {
          /**
           * targetString could be ''
           * startNodeIndex and startOffsetIndex could be null
           */
          var targetString = textStack ? textStack.slice(startOffsetIndex) : ''; // include template character
          setTargetStringInfo({
            targetString: targetString,
            startNodeIndex: startNodeIndex,
            startOffsetIndex: startOffsetIndex,
            endNodeIndex: index,
            endOffsetIndex: selection.anchorOffset
          });
          onMentionStringChange(targetString);
          return;
        }
      }
    }
  }, [isMentionEnabled]);
  var sendMessage = function sendMessage() {
    var textField = ref === null || ref === void 0 ? void 0 : ref.current;
    if (!isEdit && textField !== null && textField !== void 0 && textField.textContent) {
      var messageText = '';
      var mentionTemplate = '';
      textField.childNodes.forEach(function (node) {
        if (node.nodeType === NodeTypes.ElementNode && node.nodeName === NodeNames.Span) {
          var innerText = node.innerText,
            _node$dataset2 = node.dataset,
            dataset = _node$dataset2 === void 0 ? {} : _node$dataset2;
          var _dataset$userid = dataset.userid,
            userid = _dataset$userid === void 0 ? '' : _dataset$userid;
          messageText += innerText;
          mentionTemplate += "".concat(USER_MENTION_TEMP_CHAR, "{").concat(userid, "}");
        } else if (node.nodeType === NodeTypes.ElementNode && node.nodeName === NodeNames.Br) {
          messageText += '\n';
          mentionTemplate += '\n';
        } else if ((node === null || node === void 0 ? void 0 : node.nodeType) === NodeTypes.ElementNode && (node === null || node === void 0 ? void 0 : node.nodeName) === NodeNames.Div) {
          // handles newline in safari
          var _node$textContent = node.textContent,
            textContent = _node$textContent === void 0 ? '' : _node$textContent;
          messageText += "\n".concat(textContent);
          mentionTemplate += "\n".concat(textContent);
        } else {
          // other nodes including text node
          var _node$textContent2 = node.textContent,
            _textContent = _node$textContent2 === void 0 ? '' : _node$textContent2;
          messageText += _textContent;
          mentionTemplate += _textContent;
        }
      });
      var params = {
        message: messageText,
        mentionTemplate: mentionTemplate
      };
      onSendMessage(params);
      resetInput(ref);
      // important: keeps the keyboard open -> must add test on refactor
      textField.focus();
      setIsInput(false);
      setHeight();
    }
  };
  var isEditDisabled = !(ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && (_ref$current$textCont = _ref$current.textContent) !== null && _ref$current$textCont !== void 0 && _ref$current$textCont.trim());
  var editMessage = function editMessage() {
    var textField = ref === null || ref === void 0 ? void 0 : ref.current;
    var messageId = message === null || message === void 0 ? void 0 : message.messageId;
    if (isEdit && messageId) {
      var messageText = '';
      var mentionTemplate = '';
      textField.childNodes.forEach(function (node) {
        if (node.nodeType === NodeTypes.ElementNode && node.nodeName === NodeNames.Span) {
          var innerText = node.innerText,
            _node$dataset3 = node.dataset,
            dataset = _node$dataset3 === void 0 ? {} : _node$dataset3;
          var _dataset$userid2 = dataset.userid,
            userid = _dataset$userid2 === void 0 ? '' : _dataset$userid2;
          messageText += innerText;
          mentionTemplate += "".concat(USER_MENTION_TEMP_CHAR, "{").concat(userid, "}");
          messageText += '\n';
          mentionTemplate += '\n';
        } else {
          // other nodes including text node
          var _node$textContent3 = node.textContent,
            textContent = _node$textContent3 === void 0 ? '' : _node$textContent3;
          messageText += textContent;
          mentionTemplate += textContent;
        }
      });
      var params = {
        messageId: messageId,
        message: messageText,
        mentionTemplate: mentionTemplate
      };
      onUpdateMessage(params);
      resetInput(ref);
    }
  };
  var onPaste = usePaste({
    ref: ref,
    setMentionedUserIds: setMentionedUserIds,
    setMentionedUsers: setMentionedUsers,
    channel: channel,
    setIsInput: setIsInput,
    setHeight: setHeight
  });
  var textField = ref === null || ref === void 0 ? void 0 : ref.current;
  return /*#__PURE__*/React__default.createElement("form", {
    className: getClassName([className, isEdit ? 'sendbird-message-input__edit' : '', disabled ? 'sendbird-message-input-form__disabled' : ''])
  }, /*#__PURE__*/React__default.createElement("div", {
    className: getClassName(['sendbird-message-input', disabled ? 'sendbird-message-input__disabled' : ''])
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "".concat(textFieldId).concat(isEdit ? message === null || message === void 0 ? void 0 : message.messageId : ''),
    className: "sendbird-message-input--textarea ".concat(textFieldId),
    contentEditable: !disabled,
    role: "textbox",
    "aria-label": "Text Input",
    disabled: disabled,
    ref: ref,
    maxLength: maxLength,
    onKeyDown: function onKeyDown(e) {
      var preventEvent = _onKeyDown(e);
      if (preventEvent) {
        e.preventDefault();
      } else {
        var _textField$textConten4, _e$nativeEvent, _ref$current2, _ref$current2$childNo, _ref$current3, _ref$current3$childNo, _ref$current3$childNo2, _ref$current$childNod, _ref$current$childNod2;
        if (!e.shiftKey && e.key === MessageInputKeys.Enter && (textField === null || textField === void 0 ? void 0 : (_textField$textConten4 = textField.textContent) === null || _textField$textConten4 === void 0 ? void 0 : _textField$textConten4.trim().length) > 0 && (e === null || e === void 0 ? void 0 : (_e$nativeEvent = e.nativeEvent) === null || _e$nativeEvent === void 0 ? void 0 : _e$nativeEvent.isComposing) !== true) {
          e.preventDefault();
          sendMessage();
        }
        if (e.key === MessageInputKeys.Backspace && (ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : (_ref$current2$childNo = _ref$current2.childNodes) === null || _ref$current2$childNo === void 0 ? void 0 : _ref$current2$childNo.length) === 2 && !(ref !== null && ref !== void 0 && (_ref$current3 = ref.current) !== null && _ref$current3 !== void 0 && (_ref$current3$childNo = _ref$current3.childNodes) !== null && _ref$current3$childNo !== void 0 && (_ref$current3$childNo2 = _ref$current3$childNo[0]) !== null && _ref$current3$childNo2 !== void 0 && _ref$current3$childNo2.textContent) && (ref === null || ref === void 0 ? void 0 : (_ref$current$childNod = ref.current.childNodes) === null || _ref$current$childNod === void 0 ? void 0 : (_ref$current$childNod2 = _ref$current$childNod[1]) === null || _ref$current$childNod2 === void 0 ? void 0 : _ref$current$childNod2.nodeType) === NodeTypes.ElementNode) {
          ref === null || ref === void 0 ? void 0 : ref.current.removeChild(ref === null || ref === void 0 ? void 0 : ref.current.childNodes[1]);
        }
      }
    },
    onKeyUp: function onKeyUp(e) {
      var preventEvent = _onKeyUp(e);
      if (preventEvent) {
        e.preventDefault();
      } else {
        useMentionInputDetection();
      }
    },
    onClick: function onClick() {
      useMentionInputDetection();
    },
    onInput: function onInput() {
      var _textField$textConten5;
      setHeight();
      onStartTyping();
      setIsInput((textField === null || textField === void 0 ? void 0 : (_textField$textConten5 = textField.textContent) === null || _textField$textConten5 === void 0 ? void 0 : _textField$textConten5.trim().length) > 0);
      useMentionedLabelDetection();
    },
    onPaste: onPaste
  }), (textField === null || textField === void 0 ? void 0 : (_textField$innerText = textField.innerText) === null || _textField$innerText === void 0 ? void 0 : _textField$innerText.length) === 0 && /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-message-input--placeholder",
    type: LabelTypography.BODY_1,
    color: disabled ? LabelColors.ONBACKGROUND_4 : LabelColors.ONBACKGROUND_3
  }, placeholder || stringSet.MESSAGE_INPUT__PLACE_HOLDER), !isEdit && isInput && /*#__PURE__*/React__default.createElement(IconButton, {
    className: "sendbird-message-input--send",
    height: "32px",
    width: "32px",
    onClick: function onClick() {
      return sendMessage();
    }
  }, (renderSendMessageIcon === null || renderSendMessageIcon === void 0 ? void 0 : renderSendMessageIcon()) || /*#__PURE__*/React__default.createElement(Icon, {
    type: IconTypes.SEND,
    fillColor: disabled ? IconColors.ON_BACKGROUND_4 : IconColors.PRIMARY,
    width: "20px",
    height: "20px"
  })), !isEdit && !isInput && ((renderFileUploadIcon === null || renderFileUploadIcon === void 0 ? void 0 : renderFileUploadIcon() // UIKit Dashboard configuration should have lower priority than
  // renderFileUploadIcon which is set in code level
  ) || isFileUploadEnabled && /*#__PURE__*/React__default.createElement(IconButton, {
    className: "sendbird-message-input--attach ".concat(isVoiceMessageEnabled ? 'is-voice-message-enabled' : ''),
    height: "32px",
    width: "32px",
    onClick: function onClick() {
      var _fileInputRef$current, _fileInputRef$current2;
      // todo: clear previous input
      fileInputRef === null || fileInputRef === void 0 ? void 0 : (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : (_fileInputRef$current2 = _fileInputRef$current.click) === null || _fileInputRef$current2 === void 0 ? void 0 : _fileInputRef$current2.call(_fileInputRef$current);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: IconTypes.ATTACH,
    fillColor: disabled ? IconColors.ON_BACKGROUND_4 : IconColors.CONTENT_INVERSE,
    width: "20px",
    height: "20px"
  }), /*#__PURE__*/React__default.createElement("input", {
    className: "sendbird-message-input--attach-input",
    type: "file",
    ref: fileInputRef,
    onChange: handleUploadFile(onFileUpload)
  }))), isVoiceMessageEnabled && !isEdit && !isInput && /*#__PURE__*/React__default.createElement(IconButton, {
    className: "sendbird-message-input--voice-message",
    width: "32px",
    height: "32px",
    onClick: onVoiceMessageIconClick
  }, (renderVoiceMessageIcon === null || renderVoiceMessageIcon === void 0 ? void 0 : renderVoiceMessageIcon()) || /*#__PURE__*/React__default.createElement(Icon, {
    type: IconTypes.AUDIO_ON_LINED,
    fillColor: disabled ? IconColors.ON_BACKGROUND_4 : IconColors.CONTENT_INVERSE,
    width: "20px",
    height: "20px"
  }))), isEdit && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message-input--edit-action"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "sendbird-message-input--edit-action__cancel",
    type: ButtonTypes.SECONDARY,
    size: ButtonSizes.SMALL,
    onClick: onCancelEdit
  }, stringSet.BUTTON__CANCEL), /*#__PURE__*/React__default.createElement(Button, {
    className: "sendbird-message-input--edit-action__save",
    type: ButtonTypes.PRIMARY,
    size: ButtonSizes.SMALL,
    disabled: isEditDisabled,
    onClick: function onClick() {
      return editMessage();
    }
  }, stringSet.BUTTON__SAVE)));
});
MessageInput.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  messageFieldId: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  value: PropTypes.string,
  isEdit: PropTypes.bool,
  isMentionEnabled: PropTypes.bool,
  isVoiceMessageEnabled: PropTypes.bool,
  onVoiceMessageIconClick: PropTypes.func,
  message: PropTypes.shape({
    messageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
    mentionedMessageTemplate: PropTypes.string,
    mentionedUsers: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
  onFileUpload: PropTypes.func,
  onSendMessage: PropTypes.func,
  onUpdateMessage: PropTypes.func,
  onStartTyping: PropTypes.func,
  onCancelEdit: PropTypes.func,
  channelUrl: PropTypes.string,
  mentionSelectedUser: PropTypes.shape({
    userId: PropTypes.string,
    nickname: PropTypes.string
  }),
  setMentionedUsers: PropTypes.func,
  onUserMentioned: PropTypes.func,
  onMentionStringChange: PropTypes.func,
  onMentionedUserIdsUpdated: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  renderVoiceMessageIcon: PropTypes.func,
  renderSendMessageIcon: PropTypes.func,
  renderFileUploadIcon: PropTypes.func,
  channel: PropTypes.shape({
    channelType: PropTypes.string
  }).isRequired
};
MessageInput.defaultProps = {
  className: '',
  messageFieldId: '',
  channelUrl: '',
  onSendMessage: noop,
  onUpdateMessage: noop,
  value: null,
  message: null,
  isEdit: false,
  isMentionEnabled: false,
  isVoiceMessageEnabled: true,
  onVoiceMessageIconClick: noop,
  disabled: false,
  placeholder: '',
  maxLength: 5000,
  onFileUpload: noop,
  onCancelEdit: noop,
  onStartTyping: noop,
  mentionSelectedUser: null,
  onUserMentioned: noop,
  onMentionStringChange: noop,
  onMentionedUserIdsUpdated: noop,
  onKeyUp: noop,
  onKeyDown: noop,
  setMentionedUsers: noop,
  renderVoiceMessageIcon: noop,
  renderFileUploadIcon: noop,
  renderSendMessageIcon: noop
};
export { MessageInput as default };